export default __webpack_public_path__ + "static/media/delete.a5abcaa1.svg";